export default __webpack_public_path__ + "static/media/icon_nursecall_off.215b1657.png";